export default __webpack_public_path__ + "static/media/givepower_TM_logo_Horizontal_White.7dc31ba3.svg";